import { useQuery } from '@apollo/client';
import type { FC } from 'react';
import { useEffect } from 'react';

import type { PageContextType } from '../../context/page-context/page-context';
import { usePageContext } from '../../hooks/use-page-context/use-page-context';

import { CompaniesWorkflowStatusQueryDocument } from './companies-workflow-status.gql-types';
import { PageCreatedBanner } from './page-created-banner';
import { RepublishBanner } from './republish-banner';

type CompanyBannersContainerProps = {
  companyId?: string | null;
  isDraft: boolean;
};
export const CompanyBannersContainer: FC<CompanyBannersContainerProps> = ({
  companyId,
  isDraft,
}) => {
  const { setPageContext } = usePageContext();
  const { data, loading } = useQuery(CompaniesWorkflowStatusQueryDocument, {
    skip: !companyId,
    variables: {
      // @ts-expect-error TODO: fix this type
      id: companyId,
    },
  });

  const showPageCreatedBanner = isDraft && data?.company?.inPublicationWorkflow;
  const showRepublishBanner = isDraft && !data?.company?.inPublicationWorkflow;

  useEffect(() => {
    if (showPageCreatedBanner || showRepublishBanner) {
      setPageContext(
        (prevState) =>
          ({
            ...prevState,
            isShowingCompanyBanner: true,
          }) as PageContextType
      );
    }
  }, [data]);

  if (loading) return null;

  if (showPageCreatedBanner) {
    return <PageCreatedBanner />;
  }

  if (showRepublishBanner) {
    return <RepublishBanner />;
  }

  return null;
};
